import React from "react";
import { Modal } from "rsuite";
import "./urlmodal.css";
import Button from "./button";
import CloseIcon from "../../assets/svgs/ic_close.svg";
import { AlertNotify } from "./index";

class UrlModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      
    }
  }

  static defaultProps = {
    dialogClassName: "um_modal_view",
  };

  copyToClipboard = (url) => {
    if (url) {
      navigator.clipboard.writeText(url);
      AlertNotify.success("URL copied to clipboard");
    }
  };

  render() {
    const {
      onClose,
      title,
      buttonNames,
      open,
      urlResults,
      dialogClassName
    } = this.props;

    return (
      <Modal open={open} onClose={onClose} dialogClassName={dialogClassName}>
        <div className="um_title_view">
          <label className="um_title_style">{title}</label>
          <img
            src={CloseIcon}
            alt={"cancel"}
            className={"um_cancel_icon"}
            onClick={onClose}
          ></img>
        </div>
        <div className="um_content_view">
          {urlResults && urlResults.length > 0 ? (
            <div className="um_results_list">
              {urlResults.map((result, index) => (
                <div key={index} className="um_result_item">
                  <div className="um_email_section">
                    <label className="um_email_label">Email:</label>
                    <label className="um_email_text">{result.emailid}</label>
                  </div>
                  {result.url && (
                    <div className="um_url_section">
                      <label className="um_url_label">URL:</label>
                      <div className="um_url_with_copy">
                        <input 
                          type="text" 
                          value={result.url} 
                          readOnly 
                          className="um_url_input"
                        />
                        <button 
                          onClick={() => this.copyToClipboard(result.url)}
                          className="um_copy_button"
                        >
                          Copy
                        </button>
                      </div>
                    </div>
                  )}
                  <div className={`um_email_status ${result.sent ? 'um_success' : 'um_error'}`}>
                    {result.sent ? (
                      <label className="um_status_text">Email has been sent</label>
                    ) : (
                      <label className="um_status_text">Unable to send email</label>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="um_no_results">
              <label className="um_no_results_text">No results to display</label>
            </div>
          )}
        </div>
        <div className="um_button_view">
          <div className="um_close_button">
            <Button
              buttonName={buttonNames.close}
              onPressButton={onClose}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

export default UrlModal;
